export const SUCCESS = 'Success'
export const ERROR = 'ERROR'
